<template>
  <Modal v-model="show" :title="isAdd ? '添加里程碑' : '修改里程碑'" :closable="false" :mask-closable="false" width="600px">
    <Form ref="formData" :model="formData" :rules="rules" :label-width="120">
      <FormItem prop="event" label="里程碑内容">
        <Input type="textarea" v-model.trim="formData.event" :rows="6" placeholder="请输入" />
      </FormItem>
      <FormItem prop="unit" label="周期类型">
        <RadioGroup v-model="formData.unit">
          <Radio :label="1">天</Radio>
          <Radio :label="2">周</Radio>
          <Radio :label="3">月</Radio>
        </RadioGroup>
        <p style="color: #999">月：默认为30天</p>
      </FormItem>
      <FormItem label="周期" prop="cycle">
        <InputNumber v-model="formData.cycle" :min="1" placeholder="请输入" style="width: 100%" />
      </FormItem>
    </Form>
    <template #footer>
      <Button type="default" @click="show = false">取消</Button>
      <Button type="primary" @click="handleSubmit('formData')" :loading="loading">确定</Button>
    </template>
  </Modal>
</template>
<script>
import { Form, FormItem, Input, Modal, Button, RadioGroup, Radio, InputNumber } from 'view-design'
export default {
  components: { Form, FormItem, Input, Modal, Button, RadioGroup, Radio, InputNumber },
  props: {
    proVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    project_id: {
      type: Number,
      default: 0,
      required: true
    },
    isAdd: {
      type: Boolean,
      default: false,
      required: true
    },
    rows: {
      type: Object,
      default: () => {},
      required: false
    }
  },
  data() {
    return {
      formData: {
        unit: 1,
        cycle: 1,
        event: ''
      },
      loading: false,
      rules: {
        event: [
          {
            required: true,
            message: '请输入里程碑内容',
            trigger: 'blur'
          }
        ],
        cycle: [
          {
            type: 'number',
            required: true,
            message: '请输入周期',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.handleOk()
        }
      })
    },
    async handleOk() {
      const params = {
        uriCode: this.isAdd ? 'API033' : 'API034',
        id: this.isAdd ? undefined : this.formData.id,
        project_id: +this.project_id,
        event: this.formData.event,
        unit: this.formData.unit,
        cycle: +this.formData.cycle,
        state: this.formData.state ? '1' : '0' //0 未完成 1完成
      }
      // params.date = this.$moment(new Date(params.date)).format('YYYY-MM-DD')
      try {
        this.loading = true
        await this.$fetch(params)
      } finally {
        this.loading = false
        this.show = false
        this.$emit('ok')
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.proVisible
      },
      set(val) {
        this.$emit('update:proVisible', val)
      }
    }
  },
  watch: {
    show(val) {
      if (!val) {
        this.$refs['formData'].resetFields()
      } else {
        if (this.rows) {
          this.formData = this.isAdd
            ? {
                unit: 1,
                cycle: 1,
                event: ''
              }
            : { ...this.rows }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.w100 {
  width: 100% !important;
}
</style>
